import { render } from "./agregarSiniestro.vue?vue&type=template&id=722e8cd6&scoped=true"
import script from "./agregarSiniestro.vue?vue&type=script&lang=js"
export * from "./agregarSiniestro.vue?vue&type=script&lang=js"

import "./agregarSiniestro.vue?vue&type=style&index=0&id=722e8cd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722e8cd6"]])

export default __exports__